import NextLink from 'next/link';

import { Box, BoxProps, Center, Link, Stack } from '@chakra-ui/react';

import { range } from 'lodash';

import LinkButton from '../LinkButton/LinkButton';

interface PaginatorProps {
  currentPage: number;
  maxPage: number;
  url: string;
}

export default function Paginator({ currentPage, maxPage, url, ...boxProps }: PaginatorProps & BoxProps) {
  // Display 2 numbers to the left and 2 to the right apart from first and last 2 pages
  let displayRange: number[];

  if (maxPage < 5) {
    // Display less than 5 numbers if there are not enough pages
    displayRange = range(1, maxPage + 1);
  } else if (currentPage < 3) {
    displayRange = range(1, 6);
  } else if (currentPage >= maxPage - 2) {
    displayRange = range(maxPage - 4, maxPage + 1);
  } else {
    displayRange = range(currentPage - 2, currentPage + 3);
  }

  const generateUrl = (pageNumber: number): string => {
    if (pageNumber === 1) {
      return url;
    }
    return `${url}page/${pageNumber}/`;
  };

  return (
    <Box {...boxProps}>
      <Center>
        <Stack direction="row" alignItems="center">
          {currentPage > 1 ? (
            <LinkButton
              href={generateUrl(currentPage - 1)}
              colorScheme="blue"
              size="md"
              fontSize={['lg', null, 'xl']}
              variant="outline"
            >
              Prev
            </LinkButton>
          ) : null}
          {displayRange.map((page, index) => {
            return (
              <Link
                as={NextLink}
                href={generateUrl(page)}
                key={index}
                fontWeight="medium"
                fontSize={['lg', null, 'xl']}
                textDecoration={page === currentPage ? 'underline' : 'none'}
                color={page === currentPage ? 'gray.500' : 'blue.500'}
              >
                {page}
              </Link>
            );
          })}
          {currentPage !== maxPage ? (
            <LinkButton
              href={generateUrl(currentPage + 1)}
              colorScheme="blue"
              size="md"
              fontSize={['lg', null, 'xl']}
              variant="outline"
            >
              Next
            </LinkButton>
          ) : null}
        </Stack>
      </Center>
    </Box>
  );
}
